import { Button } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';

import {
  notificationsApi,
  UserMentionedNotificationParams,
} from 'apis/notifications';
import { HistoricalNotification } from 'components/notifications/components/notificationsPage/notificationsPage.types';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import { NotificationHistoryItem } from './notificationHistoryItem';

type MentionNotificationHistoryItemProps = {
  notification: HistoricalNotification;
  onActionHandled?: () => void;
  userMentionedData: UserMentionedNotificationParams;
};

export const MentionNotificationHistoryItem = ({
  notification,
  onActionHandled,
  userMentionedData,
}: MentionNotificationHistoryItemProps): JSX.Element => {
  const navigate = useAppNavigate();
  const [updateNotificationsAsRead] =
    notificationsApi.useLazyUpdateNotificationsAsReadQuery();

  const leftAction = useMemo(
    () => (
      <Button
        variant="secondary"
        onClick={() => {
          updateNotificationsAsRead({
            notificationIds: [notification.id],
          });

          navigate({
            path: '/conversation/:csid',
            params: {
              path: {
                csid: `${userMentionedData.mentioned_on.conversation_id}`,
              },
            },
          });

          onActionHandled?.();
        }}
      >
        Go to conversation
      </Button>
    ),
    [
      onActionHandled,
      updateNotificationsAsRead,
      navigate,
      notification.id,
      userMentionedData.mentioned_on.conversation_id,
    ],
  );
  return (
    <NotificationHistoryItem
      notification={notification}
      leftAction={leftAction}
    />
  );
};
